angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsBankAccountCtrl", [
  "$scope"
  "$stateParams"
  "$location"
  "$controller"
  "$parse"
  "$cookies"
  "CustomerApplicationService"
  "ApplicationService"
  "$http"
  "$timeout"
  "$window"
  (
    $scope
    $stateParams
    $location
    $controller
    $parse
    $cookies
    CustomerApplicationService
    ApplicationService
    $http
    $timeout
    $window
  ) ->
    $scope.page = "bank_account"

    $scope.$emit('customer_application:data', ApplicationService.data)
    angular.extend($scope, $controller("CustomerApplicationsMixinCtrl", {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))

    # Register Page View
    $scope.trackVisit()

    $scope.$on "$viewContentLoaded", ->
      $scope.tealiumView("#{$scope.page}_view", { application_page: $scope.page })

    $scope.agreedToAutoPay = false

    $scope.agreeToAutoPay = ->
      $scope.agreedToAutoPay = true

    $scope.setPaymentMethod = (payment_method) ->
      $scope.product.payment_method = payment_method

    $scope.submit = ->
      $scope.$emit "conversion:action", "submit", "bank_account"
      $scope.submitWrapper (response_data) ->
        $scope.redirectIfDifferentPage response_data, ->
          # Some error occurred as page didn't change
          $scope.closeAllLoadingModals()
          if response_data.server_side_errors and response_data.server_side_errors.length > 0
            $scope.showServerSideErrors(response_data.server_side_errors)
]
